import { useNavigate } from "react-router";
import "./header.css";
import logo from "./logo.png"


export default function Header() {

    const navigate = useNavigate();

    return(
        <div id="header">
            <div
                className="logo"
                onClick={() => navigate('/')}
            >
                <img src={logo}></img>
            </div>
        </div>
    );
}